import Checkbox from "../UI/Checkboxes/Checkbox";
import styled from "styled-components";

const StyledBurger = styled.label`
  position: relative;
  top: 0;
  left: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
  transition: all 0.3s ease-in-out;
  .burger-line {
    width: 100%;
    height: 4px;
    background: ${({ theme }) => theme.colors.invertedPrimary};
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;

    :nth-child(1) {
      transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
    }

    :nth-child(2) {
      opacity: ${({ open }) => (open ? "0" : "1")};
      transform: ${({ open }) => (open ? "translateX(20px)" : "translateX(0)")};
    }

    :nth-child(3) {
      transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(0)")};
    }
  }
  &:hover {
    opacity: 0.8;
    ${({open}) => open && `
      transform: scale(0.9);
    `}
    .burger-line {
      :nth-child(1) {
        transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(5deg)")};
      }

      :nth-child(2) {
        opacity: ${({ open }) => (open ? "0" : "1")};
        transform: ${({ open }) => (open ? "translateX(20px)" : "translateX(0)")};
      }

      :nth-child(3) {
        transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(-5deg)")};
      }
    }
  }
`

const MenuBurger = ({open, ...props}) => {
  return (
    <StyledBurger open={open}>
      <div className={"burger-line"} />
      <div className={"burger-line"} />
      <div className={"burger-line"} />
      <Checkbox isChecked={open} {...props}/>
    </StyledBurger>
  );
};

export default MenuBurger;